// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'


import store from './store'
import service from './utils/service.js'
import U from './utils/baseutil.js'
import Vant from 'vant';
import 'vant/lib/index.css';
import 'vant/lib/icon/local.css'
import '@/components'
import audio from "vue-mobile-audio";
import VueTouch from 'vue-touch'
import { Loading,Stepper,Switch } from 'vant';
import VueCookies from 'vue-cookies'
import less from 'less'
import utils from "./utils/commonutils.js"; // @ 默认的是 src 文件夹，后面省略了utils.js 后面的后缀名js
import vuetouch from './utils/vue-touch'
import './permission' // permission control
import vueEsign from 'vue-esign'

Vue.use(vueEsign)
Vue.prototype.$utils = utils;
Vue.use(less)
Vue.use(Loading);
Vue.use(audio);
Vue.use(Stepper);
Vue.use(Switch);
import './assets/styles/index.less'
Vue.use(Vant);
Vue.use(VueTouch, {name: 'v-touch'})

Vue.prototype.$ajax=service;
Vue.prototype.U=U;


import {checkPermi} from "./utils/permission.js";
Vue.prototype.checkPermi = checkPermi;
Vue.config.productionTip = false


Vue.use(VueCookies)

import moment from 'moment'

Vue.filter('dateformat', function(dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
    return moment(dataStr).format(pattern)

})

Vue.prototype.$moment=moment

let isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
Vue.prototype.$isios=isiOS;
/* eslint-disable no-new */

import jtp from './utils/jstoapp.js'
Vue.prototype.$jtp=jtp;

Vue.prototype.getViewportSize = function(){
  return {
    width: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
    height: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
  };
};
//解决replaceAll兼容性问题
String.prototype.replaceAll = function(s1,s2){
  return this.replace(new RegExp(s1,"gm"),s2);
}
import global from '../static/gloabvar.js'
Vue.prototype.$global=global;
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js